var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Topbar", { ref: "topbar" }),
      _c(
        "div",
        { staticClass: "home-container" },
        [
          _c(
            "div",
            { staticClass: "flex menu-list" },
            _vm._l(_vm.homeMenuList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "item font-weight font-20",
                  on: {
                    click: function ($event) {
                      return _vm.handleMenu(item)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      style: {
                        color:
                          _vm.activeMenu.code === item.code
                            ? "#A40000"
                            : "#000",
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                  _vm.activeMenu.code === item.code
                    ? _c("i", { staticClass: "el-icon-caret-top icon" })
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _c("columnTitle", {
            attrs: { title: _vm.activeMenu.activeName, icon: _vm.iconPush },
          }),
          _vm.activeMenu.code !== "WZJJ"
            ? _c("cmsList", {
                attrs: {
                  activeMenu: _vm.activeMenu,
                  "data-list": _vm.cmsData,
                  dataTotal: _vm.dataTotal,
                  pageNo: this.searchInfo.pageNo,
                },
                on: {
                  handleMore: _vm.handleCmsMore,
                  update: _vm.handleCurrentChange,
                },
              })
            : _c("introduce"),
          _vm.activeMenu.code == "SYWZ"
            ? _c("columnTitle", {
                attrs: { title: "考生入口", icon: _vm.iconInto },
              })
            : _vm._e(),
          _vm.activeMenu.code == "SYWZ" ? _c("entrance") : _vm._e(),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }